interface DrawTallyOpts {
    count?: number;
    size?: number;
    strokeColor?: string;
    strokeWidth?: number;
}

export function drawTallyMarks(canvas: HTMLCanvasElement, opts?: DrawTallyOpts): void {
    if (!(canvas instanceof HTMLCanvasElement)) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const { count = 0, size = 400, strokeColor = '#333333', strokeWidth = 2 } = opts ?? {};

    const groupWidth = 30;
    const groupHeight = 35;
    const horizontalSpacing = 15;
    const verticalSpacing = 20;
    const padding = 30;

    const safeCount = Math.min(count, 2500);

    let simX = padding;
    let simY = padding;
    for (let i = 0; i < safeCount; i++) {
        const markInGroup = i % 5;
        if (markInGroup === 0 && i > 0) {
            if (simX + groupWidth > size - padding) {
                simX = padding;
                simY += groupHeight + verticalSpacing;
            }
        }
        if (markInGroup === 4) {
            simX += groupWidth + horizontalSpacing;
        }
    }
    const canvasHeight = Math.max(size, simY + groupHeight + padding);

    const dpr = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    canvas.width = Math.round(size * dpr);
    canvas.height = Math.round(canvasHeight * dpr);
    canvas.style.width = `${size}px`;
    canvas.style.height = `${canvasHeight}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    ctx.clearRect(0, 0, size, canvasHeight);

    ctx.strokeStyle = strokeColor;
    ctx.lineWidth = strokeWidth;
    ctx.lineCap = 'round';

    let currentX = padding;
    let currentY = padding;

    for (let i = 0; i < safeCount; i++) {
        const markInGroup = i % 5;

        if (markInGroup === 0 && i > 0) {
            if (currentX + groupWidth > size - padding) {
                currentX = padding;
                currentY += groupHeight + verticalSpacing;
            }
        }

        if (markInGroup < 4) {
            const x = currentX + markInGroup * (groupWidth / 4);
            ctx.beginPath();
            ctx.moveTo(x, currentY);

            const tilt = ((i % 3) - 1) * 2;
            ctx.lineTo(x + tilt, currentY + groupHeight);
            ctx.stroke();
        } else {
            ctx.beginPath();
            ctx.moveTo(currentX - 5, currentY + groupHeight - 5);
            ctx.lineTo(currentX + groupWidth - 5, currentY + 5);
            ctx.stroke();

            currentX += groupWidth + horizontalSpacing;
        }
    }
}

export const tallyMarks = {
    key: 'tally-marks',
    name: 'Tally Marks',
    draw: drawTallyMarks,
    meta: {
        title: 'Tally Marks',
        description: 'Visualise numbers using tally marks.',
        icon: '||||',
        href: '/methods/tally-marks',
    },
};

export default drawTallyMarks;
